import type { AgentTreeNode, AgentTreeView } from '../types';

export interface SubSessionView {
  /** Root-to-viewed-node path, so the breadcrumb shows the node's position. */
  path: AgentTreeNode[];
  node: AgentTreeNode;
  parent: AgentTreeNode;
}

/** Undefined while the main session is viewed — a sub-session is any deeper node. */
export function resolveSubSession(tree: AgentTreeView | undefined): SubSessionView | undefined {
  if (!tree || tree.activeViewPath.length < 2) return undefined;
  const path = nodesAlongPath(tree);
  if (!path) return undefined;
  return { path, node: path[path.length - 1], parent: path[path.length - 2] };
}

function nodesAlongPath(tree: AgentTreeView): AgentTreeNode[] | undefined {
  const [rootId, ...childIds] = tree.activeViewPath;
  if (rootId !== tree.root.id) return undefined;

  const path = [tree.root];
  for (const id of childIds) {
    const child = path[path.length - 1].children.find((candidate) => candidate.id === id);
    if (!child) return undefined;
    path.push(child);
  }
  return path;
}
